
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface AuthHeaderProps {
  authMode: 'login' | 'signup' | 'admin';
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ authMode }) => {
  const getDescription = () => {
    switch (authMode) {
      case 'login':
        return 'Sign in to manage your bin washing subscriptions';
      case 'signup':
        return 'Create an account to get started with our bin washing service';
      case 'admin':
        return 'Admin access only - Login to manage system';
      default:
        return '';
    }
  };

  return (
    <CardHeader>
      <CardTitle className="text-2xl">Welcome to Bins and Things</CardTitle>
      <CardDescription>{getDescription()}</CardDescription>
    </CardHeader>
  );
};

export default AuthHeader;
